module.exports = __webpack_public_path__ + "static/img/banner-2.b8705a1e.png";